import { NgModule } from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared.module';
import { CardsModule } from 'src/app/views/cards/cards.module';
import { FormsConstructorModule } from '../../forms/forms-constructor.module';
import { BasicSearchComponent } from './search-component/basic-search/basic-search.component';
import { InviteToSocialGroupSearchComponent } from './search-component/invite-to-social-group/invite-to-social-group-page/invite-to-social-group-search.component';
import { SharedSearchComponent } from './search-component/shared-search/shared-search.component';
import { SearchFieldsComponent } from './search-fields/search-fields.component';
import { SearchResultsComponent } from './search-results/basic-search-results/search-results.component';
import { SearchResultsInviteComponent } from './search-results/invite-search-results/invite-search-results.component';
import { SearchResultsSharedComponent } from './search-results/search-results-shared/search-results-shared.component';
import { SearchService } from './search.service';

@NgModule({
  declarations: [
    SharedSearchComponent,
    BasicSearchComponent,
    InviteToSocialGroupSearchComponent,
    SearchFieldsComponent,
    SearchResultsSharedComponent,
    SearchResultsComponent,
    SearchResultsInviteComponent,
  ],
  imports: [SharedModule, NgbPaginationModule, CardsModule, FormsConstructorModule],
  providers: [SearchService],
})
export class SearchModule {}
